import { Box } from "@mui/material";
import HtmlWithLatex from "../pages/QuestionBank/components/HtmlWithLatex";

export function PreviewLatex({ html, sx, inline = false }) {
  return (
    <Box
      sx={{
        display: inline ? "inline-block" : "block",
        verticalAlign: inline ? "middle" : undefined,
        minWidth: 0,
        maxWidth: "100%",
        "& .MathJax, & .MathJax_Display": { fontSize: "1em !important" },
        ...sx,
      }}
    >
      <HtmlWithLatex
        html={html == null ? "" : String(html)}
        style={inline ? { display: "inline-block", verticalAlign: "middle" } : undefined}
      />
    </Box>
  );
}
